var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoutesDeactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7166_199210)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1579 17.7696L8.50688 17.7756C8.01688 17.7756 7.55488 17.5846 7.20988 17.2386C6.86288 16.8926 6.67188 16.4316 6.67188 15.9426V14.9456C6.67188 13.9346 7.49388 13.1126 8.50588 13.1126H14.6469C16.4779 13.1126 17.9729 11.6226 17.9809 9.79159L17.9859 8.78059C17.9899 7.88559 17.6439 7.04459 17.0119 6.41259C16.3829 5.78159 15.5449 5.43359 14.6499 5.43359H14.6419L12.1439 5.44859C11.7299 5.45159 11.3969 5.78859 11.3989 6.20259C11.4009 6.61559 11.7369 6.94859 12.1489 6.94859H12.1539L14.6489 6.93359H14.6529C15.1429 6.93359 15.6039 7.12459 15.9509 7.47159C16.2979 7.82059 16.4879 8.28259 16.4859 8.77359L16.4809 9.78559C16.4769 10.7926 15.6539 11.6126 14.6469 11.6126H8.50588C6.66788 11.6126 5.17188 13.1076 5.17188 14.9456V15.9426C5.17188 16.8326 5.51788 17.6696 6.14888 18.2996C6.77888 18.9286 7.61588 19.2756 8.50688 19.2756H8.50887L12.1589 19.2696C12.5729 19.2686 12.9089 18.9326 12.9079 18.5186C12.9069 18.1046 12.5719 17.7696 12.1579 17.7696Z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76672 6.37195C6.35672 6.37195 6.01672 6.05195 6.01672 5.64195V5.61195C6.01672 5.19195 6.35672 4.86195 6.76672 4.86195C7.18672 4.86195 7.51672 5.19195 7.51672 5.61195C7.51672 6.02195 7.18672 6.37195 6.76672 6.37195ZM6.76672 9.79195C7.57672 9.79195 9.89672 7.67195 9.89672 5.63195C9.89672 3.90195 8.49672 2.50195 6.76672 2.50195C5.03672 2.50195 3.63672 3.90195 3.63672 5.63195C3.63672 7.67195 5.95672 9.79195 6.76672 9.79195Z",
    fill: "#484848"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2355 18.0929C16.8255 18.0929 16.4855 17.7729 16.4855 17.3529V17.3229C16.4855 16.9129 16.8255 16.5729 17.2355 16.5729C17.6455 16.5729 17.9855 16.9129 17.9855 17.3229C17.9855 17.7329 17.6455 18.0929 17.2355 18.0929ZM17.2355 14.2129C15.5155 14.2129 14.1055 15.6229 14.1055 17.3429C14.1055 19.3929 16.4355 21.5029 17.2355 21.5029C18.0455 21.5029 20.3655 19.3929 20.3655 17.3429C20.3655 15.6229 18.9655 14.2129 17.2355 14.2129Z",
    fill: "#484848"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7166_199210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoutesDeactive);
export default __webpack_public_path__ + "static/media/routes_deactive.c3e1920d49a4f3bc6355bf5a6c82fb18.svg";
export { ForwardRef as ReactComponent };